<script setup lang="ts">
import { RouteName } from '@/router/models/route-name';
import router from '@/router/router';
import { entraAuthService } from '@/services/auth/entra-auth-service';
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const { isLoggedIn } = entraAuthService;

onMounted(async () => {
  if (isLoggedIn.value) {
    await router.push({ name: RouteName.Projects });
  }
});

const login = async () => {
  await entraAuthService.login();
};
</script>

<template>
  <section v-if="!isLoggedIn" class="container mt-6">
    <p>{{ t('notLoggedIn') }}</p>
    <button class="button is-primary mt-4" @click="login">
      {{ t('loginButton') }}
    </button>
  </section>
</template>
